import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { getIsConfigReady } from "../../store/configSlice";
import { getIsTransportReady, getTransports } from "../../store/transportSlice";

import { prepareAll } from "./icons";
import { Map } from "./Map";
import { LeafletInstance } from "./LeafletInstance";

import { Sidebar } from "../Sidebar/Sidebar";

import style from "./Map.module.scss";

const INIT = 0;
const PENDING = 1;
const READY = 2;

const NODE_ID = "map";

// Не даём срендериться карте до тех пор, пока не появится конфиг и мы не прогрузим размеры всех необходимых иконок
export function MapPrepareBody({
    isConfigReady,
    isTransportReady,
    transports,
}) {
    const [transportPrepareState, setTransportPrepareState] = useState(INIT);

    useEffect(() => {
        if (isTransportReady && transportPrepareState === INIT) {
            const iconUrlList = transports.map(({ iconUrl }) => iconUrl);

            prepareAll(iconUrlList).then(() => {
                setTransportPrepareState(READY);
            });

            setTransportPrepareState(PENDING);
        }
    }, [
        isTransportReady,
        transports,
        transportPrepareState,
        setTransportPrepareState,
    ]);

    return (
        <>
            <div
                className={style.mapContainer}
                style={{ position: "relative" }}
            >
                <Sidebar />
                <LeafletInstance nodeId={NODE_ID} />
                {isConfigReady && transportPrepareState === READY ? (
                    <Map nodeId={NODE_ID} />
                ) : null}
            </div>
        </>
    );
}

MapPrepareBody.propTypes = {
    isConfigReady: PropTypes.bool.isRequired,
    isTransportReady: PropTypes.bool.isRequired,
    transports: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            number: PropTypes.string.isRequired,
            time: PropTypes.number.isRequired,
            lng: PropTypes.number.isRequired,
            lat: PropTypes.number.isRequired,
            speed: PropTypes.number.isRequired,
            company: PropTypes.string.isRequired,
            iconUrl: PropTypes.string.isRequired,
            type: PropTypes.string.isRequired,
        })
    ).isRequired,
};

const MapPrepare = connect((state) => ({
    isConfigReady: getIsConfigReady(state),
    isTransportReady: getIsTransportReady(state),
    transports: getTransports(state),
}))(MapPrepareBody);

MapPrepare.propTypes = {};

export { MapPrepare };
